import { onAuthStateChanged } from 'firebase/auth';
import { newAuth } from '@/firebase/firebaseInit';
import { getUserAddDataFromLocalStorage } from '@/utils/userUtils';

/**
 * Firebase shares the signed-in user across tabs, but each tab keeps rendering the session it
 * loaded with. Without this, a tab left open as user A signs its requests with user B's token
 * after B logs in elsewhere.
 */
export function syncTabWithAuthUser(): void {
  const tabUid: string | null = getUserAddDataFromLocalStorage().uid;
  if (!tabUid) {
    return;
  }

  let hasInitialState = false;
  onAuthStateChanged(newAuth, (user) => {
    const isInitialState = !hasInitialState;
    hasInitialState = true;
    if (user?.uid === tabUid) {
      return;
    }

    // Signed out, or mismatched on load (where a reload would land here again): end the session.
    if (!user || isInitialState) {
      localStorage.removeItem('userAddData');
      window.location.assign('/auth/login');
      return;
    }

    window.location.reload();
  });
}
